import React from 'react'
import {
  Route,
  withRouter
} from 'react-router-dom'

import PrivateRoute from '../login/PrivateRoute'
import JobsContainer from '../jobs/JobsContainer'
import JobsFormContainer from '../jobs/JobsFormContainer'
import AssignDriverContainer from '../jobs/AssignDriverContainer'
import LocationsContainer from '../locations/LocationsContainer'
import LocationFormContainer from '../locations/LocationFormContainer'
import LoginContainer from '../login/LoginContainer'
import PaymentContainer from '../payments/PaymentContainer'
import ManifestContainer from '../jobs/ManifestContainer'
import ProductFormContainer from '../products/ProductFormContainer'
import ProductEditFormContainer from '../products/ProductEditFormContainer'
import ProductListContainer from '../products/ProductListContainer'
import ProductPriceContainer from '../products/ProductPriceContainer'
import InvoicesContainer from '../jobs/InvoicesContainer'

const Routes = ({location}) =>
  <div id='content'>
    <Route exact path='/login' component={LoginContainer} location={location} />
    <PrivateRoute exact path='/' component={JobsContainer} location={location} />
    <PrivateRoute exact path='/jobs' component={JobsContainer} location={location} />
    <PrivateRoute exact path='/jobs/form' component={JobsFormContainer} location={location} />
    <PrivateRoute exact path='/job/:jobId/assign-driver' component={AssignDriverContainer} location={location} />
    <PrivateRoute exact path='/job/:jobId/invoices' component={InvoicesContainer} location={location} />
    <PrivateRoute exact path='/locations' component={LocationsContainer} location={location} />
    <PrivateRoute exact path='/locations/form' component={LocationFormContainer} location={location} />
    <PrivateRoute exact path='/payments' component={PaymentContainer} location={location} />
    <PrivateRoute exact path='/manifest/:jobId/:stopId' component={ManifestContainer} location={location} />
    <PrivateRoute exact path='/products/form' component={ProductFormContainer} location={location} />
    <PrivateRoute exact path='/products/:productId/edit' component={ProductEditFormContainer} location={location} />
    <PrivateRoute exact path='/products' component={ProductListContainer} location={location} />
    <PrivateRoute exact path='/products/:productId/prices' component={ProductPriceContainer} location={location} />
  </div>

export default withRouter(Routes)



// WEBPACK FOOTER //
// ./src/app/Routes.js